import routes from '../../router/routes'
const route={
    state: {
        routes
    },
    mutations: {
    },
    actions: {
    },
}
export default route;